import { useMemo } from 'react';

import { BaseContainer } from '../Container';
import { MarketContainer } from './MarketContainer';
import { AdvancedChart } from '../TVChart';
import useMarkets from '../../contexts/MarketsContext';
import { useLivePastDayHourlyCandlesSubscription } from '../../graphql/generated';
import { formatMarketInfo, formatMarketVolume } from '../../utils/helpers';
import { GenericCandle } from '../../hooks/types';

export function Market() {
  const { selectedMarket } = useMarkets();
  const [tradesQuery] = useLivePastDayHourlyCandlesSubscription({
    variables: {
      marketId: selectedMarket?.id ?? '0',
      from: Math.round(Date.now().valueOf() / 1000) - 24 * 60 * 60,
    },
  });

  const {
    price,
    mark,
    index,
    high,
    low,
    priceChange,
    priceChangeVal,
    openInterest,
    liquidity,
    fundingRate,
    fundingRateVal,
  } = useMemo(() => formatMarketInfo(selectedMarket), [selectedMarket]);

  const volume = useMemo(
    () =>
      formatMarketVolume(tradesQuery?.data?.market?.hourlyCandles as GenericCandle[] | undefined),
    [tradesQuery],
  );

  return (
    <BaseContainer>
      <MarketContainer
        price={price}
        mark={mark}
        index={index}
        fundingRate={fundingRate}
        fundingRateVal={fundingRateVal}
        high={high}
        low={low}
        vol={volume}
        priceChange={priceChange}
        priceChangeVal={priceChangeVal}
        openInterest={openInterest}
        liquidity={liquidity}
      >
        <AdvancedChart />
      </MarketContainer>
    </BaseContainer>
  );
}
